import { SupplierArrayField } from 'models/entities/supplier';
import { StringArrayField } from 'models/value-objects/editor-field';

type Data = {
  field: SupplierArrayField;
};

class Model {

  readonly field: SupplierArrayField;
  readonly stringArrayField: StringArrayField;

  constructor(data: Data) {
    this.field = data.field;
    this.stringArrayField = new StringArrayField({ list: this.field.list.map(it => it.name), string: this.field.object?.name });
  }

  apply(stringArrayField: StringArrayField): this {
    const field = this.field.change(stringArrayField.index);
    return Object.assign(Object.create(this.constructor.prototype), { ...this, field, stringArrayField });
  }

}

export { Model };
